module.exports = __webpack_public_path__ + "img/geod_3.c6a4d621.jpg";